// USA
export const locale = {
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  MENU: {
    NEW: "new",
    ACTIONS: "Actions",
    CREATE_POST: "Create New Post",
    PAGES: "Pages",
    FEATURES: "Features",
    APPS: "Apps",
    TITLE: "Menu",
    DASHBOARD: {
      TITLE: "Dashboard"
    },
    PROFILE: {
      TITLE: "profile"
    },
    LOGOUT: {
      TITLE: "Sign out"
    },
    COMPANY_MANAGEMENT: {
      TITLE: "Company management",
      COMPANY: "Company"
    },
    CAMPAIGN_MANAGEMENT: {
      TITLE: "Campaign management",
      CAMPAIGN: "Campaign"
    },
    RECEIPT_TYPE_MANAGEMENT: {
      TITLE: "Receipt type management",
      RECEIPT_TYPE: "Receipt type"
    }
  },
  AUTH: {
    TITLE: "Kepttam",
    GENERAL: {
      OR: "Or",
      SUBMIT_BUTTON: "Submit",
      NO_ACCOUNT: "Don't have an account?",
      SIGNUP_BUTTON: "Sign Up",
      FORGOT_BUTTON: "Forgot Password",
      BACK_BUTTON: "Back",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    LOGIN: {
      TITLE: "Login Account",
      BUTTON: "Sign In"
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUCCESS: "Your account has been successfully reset."
    },
    UPDATE_PASSWORD: {
      TITLE: "New password",
      DESC: "The code used to change the password has been sent to your email address.",
      TIME_ALEAT: "Please change password within {second} seconds.",
      TIMEOUT: "Code expired"
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUCCESS: "Your account has been successfuly registered.",
      NEW_USER: "New Here?",
      CREATE_ACCOUNT: "Create an Account",
      CONFIRM_REGISTER:
        "You have successfully subscribed. Please check your email to confirm your subscription."
    },
    INPUT: {
      EMAIL: "Email",
      FULLNAME: "Fullname",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      USERNAME: "Username",
      CODE: "Code",
      NEW_PASSWORD: "New password",
      CONFIRM_NEW_PASSWORD: "Confirm new password",
      COMPANY_NAME: "Company name",
      SUBMIT: "Submit",
      CANCEL: "Cancel"
    },
    VALIDATION: {
      INVALID: "Field is not valid",
      REQUIRED: "Field is required",
      MIN_LENGTH: "Field minimum length is {min}",
      MAX_LENGTH: "Field maximum length is {max}",
      MIN_MAX_LENGTH:
        "Field minimum length is {min} and maximum length is {max}",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "Field is not valid",
      CUSTOM_REQUIRED: "{field} is required"
    }
  },
  PAGE: {
    DEFAULT: {
      TABLE: {
        SEARCH: "Search",
        CLEAR: "clear",
        NEW: "New",
        DATA_NOT_FOUND: "Data not found",
        FIELDS: {
          INDEX: "Index",
          NAME: "Name",
          SWITCH: "Enable",
          QUANTITY: "Quantity",
          POINT: "Point",
          STATUS: {
            TITLE: "Status",
            ACTIVE: "Active",
            INACTIVE: "Inactive",
            WAITING_APPROVE: "Waiting approve",
            APPROVED: "Approved",
            REWARD_RECEIVED: "Reward received",
            REWARD_WAITING: "Waiting for reward pickup",
            UNAPPROVED: "Unapproved"
          },
          ACTION: {
            TITLE: "Action",
            EDIT: "Edit",
            DELETE: {
              TITLE: "Delete",
              DESC: "Confirm data deletion"
            }
          }
        },
        PER_PAGE: "Per page"
      },
      FORM: {
        TITLE: "Form",
        FIELDS: {
          NAME: "Name",
          DETAIL: "Detail",
          START_DATE: "Start date",
          TYPEREWORD: "Type of reward",
          MODE_OF_CAMPAIGN: "Mode of campaign",
          END_DATE: "End date",
          IMAGE: "Image",
          MAIN_IMAGE: "Main image",
          OTHER_IMAGE: "Other image",
          QUANTITY: "Quantity",
          POINT: "Point"
        },
        PLACEHOLDER: {
          CHOOSE_DATE: "Choose date",
          CHOOSE_IMAGE: "Choose an image."
        },
        OPTIONS: {
          ALL: "All",
          CUSTOM: "Custom",
          ON: "On",
          OFF: "Off"
        },
        BTN_SUBMIT: "Submit",
        BTN_OK: "Ok",
        BTN_CANCEL: "Cancel",
        BTN_ADD: "ADD",
        VALIDATION: {
          INVALID: "Field is not valid",
          REQUIRED: "Field is required",
          MIN_LENGTH: "Field minimum length is {min}",
          MAX_LENGTH: "Field maximum length is {max}",
          MIN_MAX_LENGTH:
            "Field minimum length is {min} and maximum length is {max}",
          CHECK_DATA_ALL_TAB:
            "Some field is not valid. Please check data in all tab.",
          DUPLICATE: "Data is exit",
          MIN_VALUE: "Value must be at least {min}"
        },
        PS_NOTE: {
          MIN_RECORD: "Field minimum record is 1"
        }
      }
    },
    DASHBOARD: {},
    PROFILE: {
      TABLE: {
        FIELDS: {
          FULLNAME: "Fullname",
          EMAIL: "Email"
        }
      },
      FORM: {
        TABS: {
          DATA: "Data",
          PASSWORD: "Password"
        },
        FIELDS: {
          FULLNAME: "Fullname",
          EMAIL: "Email",
          OLD_PASSWORD: "Old password",
          NEW_PASSWORD: "new password",
          CONFIRM_NEW_PASSWORD: "Confirm new password"
        }
      }
    },
    COMPANY_MANAGEMENT: {
      TABLE: {
        FIELDS: {
          NAME: "Name",
          PLAN: "Plan"
        }
      },
      FORM: {
        SECTION_COMPANY: "Company profile",
        SECTION_PLAN: "Subscription plan",
        FIELDS: {
          LOGO_IMAGE: "Logo",
          NAME: "Name",
          PLAN: "Plan",
          PLAN_EXPIRES: "Expiry date (optional)"
        },
        PLAN_HINT:
          "If unset, the server uses Starter limits until a plan is assigned.",
        BTN_SAVE_PLAN: "Save plan",
        PLAN_ON_CREATE_HINT:
          "Choose a plan and submit the form below — the plan is saved when the company is created."
      }
    },
    COMPANY: {
      FORM: {
        FIELDS: {
          LOGO_IMAGE: "Logo image"
        }
      }
    },
    RECEIPT_TYPE: {
      TABLE: {
        FIELDS: {
          LIMIT_VALIDATOR: "Minimum validation length",
          SORT_NUMBER: "Sort number"
        }
      },
      FORM: {
        FIELDS: {
          LIMIT_VALIDATOR: "Minimum validation length",
          SORT_NUMBER: "Sort number",
          GRAPH_COLOR: "Graph color",
          LOGO_IMAGE: "Logo image",
          PREVIEW_IMAGE: "Receipt preview image",
          OCR_SYSTEM_PROMPT: "OCR Prompt (AI instructions for this receipt type)"
        }
      }
    },
    CAMPAIGN_REFERRAL: {
      TABLE: {
        FIELDS: {
          INVITER: "Inviter",
          INVITEE: "Invitee",
          INVITER_POINT: "Inviter points",
          INVITEE_POINT: "Invitee points"
        }
      }
    },
    CAMPAIGN: {
      TABLE: {
        BUTTON: {
          NEW_CAMPAIGN_RECEIPT: "New campaign receipt"
        },
        FIELDS: {
          CAMPAIGN_URL: "CAMPAIGN URL",
          START_DATE: "Start date",
          END_DATE: "End date",
          CREATED_AT: "Date",
          CUSTOMER: "Customer",
          RECEIPT_TYPE: "Receipt type",
          POINT: "Point",
          VERIFY_CODE: "Verify code",
          REMARK: "Remark"
        }
      },
      FORM: {
        HINT: {
          IS_ACTIVE: "Please update your LINE LIFF ID to activate the event."
        },
        MODAL: {
          PRODUCT_TITLE: "Product form",
          REWARD_TITLE: "Reward form",
          CUSTOMER_RECEIPT: "Customer receipt",
          CUSTOMER_RECEIPT_REWARD: "Customer reward redemption"
        },
        ACTIVE_WARNING:
          'When "LINE LIFF ID" is update.<br> This Campaign will be active when date is equal start and then you cannot edit campaign data.',
        CONFRIM_ENABLE:
          "Do you want to <span style='color:green'>enable</span> activity to use it?",
        CONFRIM_DISABLE:
          "Do you want to <span style='color:red'>disable</span> the activity?",
        CAMPAIGN_RECEIPT: {
          TITLE: "Campaign receipt form",
          TAB: {
            GENERAL: "General",
            RECEIPT: "Receipt type",
            PRODUCT: "Product",
            REWARD: "Reward",
            CUSTOMER: "Customer",
            REFERRAL: "Referral history",
            MEMBERS: "Members",
            SEGMENTS: "Customer segments"
          },
          MEMBERS: {
            TOTAL_LABEL: "Total members",
            TOTAL_POINTS_LABEL: "Total points",
            TOTAL_REDEMPTIONS_LABEL: "Prize redemptions",
            LOADING_COUNT: "Loading…",
            COUNT_UNAVAILABLE: "Could not load member count",
            POINTS_UNAVAILABLE: "Could not load total points",
            REDEMPTIONS_UNAVAILABLE: "Could not load redemption count",
            JOINED_FILTER: "Joined",
            FILTER_ALL: "All",
            FILTER_NEW_TODAY: "New today",
            FILTER_NEW_MONTH: "New this month",
            COL_NAME: "Name",
            COL_PHONE: "Phone",
            COL_JOINED: "Campaign joined at",
            COL_CUSTOMER_REGISTERED: "Registered (customer)",
            ACTION_PROFILE: "Profile",
            ACTION_POINTS: "Point history",
            ACTION_REDEMPTION: "Redemption history",
            ACTION_VIEW_DETAIL: "View details",
            PAGE_MEMBER_DETAIL_TITLE: "Member details",
            TAB_PROFILE: "Profile",
            TAB_POINTS: "Point history",
            TAB_REDEMPTION: "Redemption history",
            LIST_UNAVAILABLE: "Could not load the list (server API pending)",
            BTN_BACK: "Back to campaign",
            PAGE_PLACEHOLDER:
              "This page will show details when the API is available.",
            PAGE_PROFILE_TITLE: "Member profile",
            PAGE_POINTS_TITLE: "Point accumulation history",
            PAGE_REDEMPTION_TITLE: "Redemption history",
            MEMBER_REF: "Member #",
            PROFILE_CUSTOMER: "Customer",
            PROFILE_POINTS: "Total points",
            MEMBER_JOINED: "Joined",
            LOAD_ERROR_DETAIL: "Could not load data",
            COL_POINT: "Points",
            COL_VERIFY_CODE: "Reference code",
            COL_VERIFY_CODE_RECEIPT: "Verification code",
            COL_RECEIPT_TYPE: "Receipt type",
            COL_STATUS: "Status",
            COL_REMARK: "Remarks",
            COL_REWARD: "Reward",
            COL_DATE: "Date"
          },
          SEGMENTS: {
            FILTER_HINT:
              "Only approved receipts count, by receipt created date in the selected range (leave dates empty to include all time).",
            MIN_RECEIPTS_LABEL: "Minimum receipts (in range)",
            BTN_EXPORT: "Export Excel",
            COL_RECEIPT_COUNT: "Receipts counted in range",
            COL_RECEIPT_LIST: "Receipt no. / submitted at",
            START_DATE_LABEL: "Start date (receipt)",
            END_DATE_LABEL: "End date (receipt)",
            BTN_LOAD: "Load list",
            LIST_UNAVAILABLE: "Could not load the list",
            EXPORT_FAILED: "Export failed",
            MEMBER_CAP_LABEL: "Member Cap Usage",
            CAP_IN_USE: "in use",
            CAP_PLAN: "Plan: {plan} · {n} remaining",
            INSIGHT_TITLE: "Interesting Insight",
            INSIGHT_CTA: "View recommended plan →",
            INSIGHT_HTML:
              'Group <strong style="color:#fbbf24">At Risk increased 8.1%</strong> this month — 1,422 customers are about to churn. ' +
              "Try sending a win-back coupon before they become Lapsed · " +
              'Approaching Member Cap — consider <strong style="color:#fbbf24">upgrading to Pro</strong>',
            SECTION_TABS_LABEL: "02 · Segment by perspective",
            SECTION_TABS_HINT: "— choose a tab by objective",
            TAB_ENGAGEMENT: "A · By Engagement",
            TAB_RECEIPT_ACTIVITY: "B · By Receipt Activity",
            TAB_DEMOGRAPHIC: "C · By Demographic",
            TAB_REWARD: "D · By Reward",
            ENG_CHART_TITLE: "Member proportion by Engagement",
            TREND_ACTIVE_LABEL: "Active — trend",
            RECEIPT_DIST_TITLE: "📄 Receipts per person",
            RECEIPT_DIST_SUB: "All campaigns · {n} people",
            RECEIPT_BREAK_TITLE: "Total receipts submitted this month — {n}",
            SPEND_TITLE: "💰 Total spend per person",
            SPEND_SUB: "Approved receipts only · {n} people",
            SPEND_COL_TIER: "TIER",
            SPEND_COL_RANGE: "Spend range",
            SPEND_COL_COUNT: "Count",
            PARETO_NOTE:
              "💡 HIGH tier customers {pct}% generated total revenue {revenue} or {share}% of all revenue",
            FREQ_TITLE: "📅 Average receipt submission frequency",
            FREQ_SUB: "Only members with ≥2 receipts · {n} people",
            FRAUD_TITLE: "Found {n} members with abnormal Reject rate",
            FRAUD_BODY:
              "These members have a receipt reject rate higher than {threshold}% " +
              "(overall average {average}%). " +
              "This may indicate duplicate, forged, or incomplete receipts — please review.",
            FRAUD_CTA: "View {n} members →",
            FOOTER_CRITERIA: "Grouping criteria:",
            FOOTER_CALC:
              "Segments are recalculated automatically every 24 hrs based on the latest receipt submission date and active campaigns",
            FOOTER_ACTIVE_DEF: "= submitted an approved receipt within the last 30 days",
            FOOTER_CAP_DEF: "cumulative over account lifetime per pricing policy v2.2",
            KPI_TOTAL_LABEL: "Total Members",
            KPI_TOTAL_SUFFIX: "people",
            KPI_TOTAL_META: "vs last month · +912",
            KPI_ACTIVE_LABEL: "Active",
            KPI_ACTIVE_SUB: "30 days",
            KPI_ACTIVE_META: "37.7% of base",
            KPI_RISK_LABEL: "At Risk",
            KPI_RISK_SUB: "30–60 days",
            KPI_RISK_META: "needs win-back",
            KPI_LAPSED_LABEL: "Lapsed",
            KPI_LAPSED_SUB: "60+ days",
            KPI_LAPSED_META: "35.9% of base",
            SEG_NEW_NAME: "New",
            SEG_NEW_DEF: "Registered within 7 days · no receipts yet",
            SEG_NEW_ACTION: "Onboard",
            SEG_ACTIVE_NAME: "Active",
            SEG_ACTIVE_DEF: "Submitted ≥1 receipt in the last 30 days",
            SEG_ACTIVE_ACTION: "Upsell",
            SEG_RISK_NAME: "At Risk",
            SEG_RISK_DEF: "Was active but silent for 30–60 days",
            SEG_RISK_ACTION: "Win-back",
            SEG_LAPSED_NAME: "Lapsed",
            SEG_LAPSED_DEF: "Silent for more than 60 days",
            SEG_LAPSED_ACTION: "Reactivate",
            SEG_VIP_NAME: "VIP",
            SEG_VIP_DEF: "Top 10% by cumulative receipts / spend",
            SEG_VIP_ACTION: "Reward",
            DIST_0: "0 receipts",
            DIST_1: "1 receipt",
            DIST_2_5: "2–5 receipts",
            DIST_6_PLUS: "6+ receipts",
            FREQ_WEEKLY: "Weekly",
            FREQ_MONTHLY: "Monthly",
            FREQ_BI_MONTHLY: "Every 2–3 months",
            FREQ_OCCASIONAL: "Occasionally",
            FREQ_LOYAL_TAG: "⭐ Loyal"
          },
          TAB_DASHBOARD: {
            CAMPAIGN_LINE_X: "Date",
            CAMPAIGN_LINE_Y: "Players",
            CUSTOMER_LINE_EXPORT_USER_COUNT: "Active users (joined that day)",
            CUSTOMER_LINE_EXPORT_RECEIPT_COUNT: "Receipts submitted (total)",
            CUSTOMER_LINE_EXPORT_USER_NAMES: "User names",
            RECEIPT_TYPE: "Receipt types",
            RECEIPT_TYPE_EXPORT_COL_TYPE: "Receipt type",
            RECEIPT_TYPE_EXPORT_COUNT: "Total receipts (in range)",
            RECEIPT_TYPE_EXPORT_SENDERS: "Senders (unique)",
            UNAPPROVED_EXPORT_COL_REASON: "Rejection reason",
            UNAPPROVED_EXPORT_COUNT: "Rejected receipts (per reason)",
            UNAPPROVED_EXPORT_OWNERS: "Receipt owners (rejected by admin)",
            REWARD: "Prize redemption",
            REWARD_REDEEM_EXPORT_COL_NAME: "Reward item",
            REWARD_REDEEM_EXPORT_TOTAL_VALUE: "Total value (points) per item",
            REWARD_REDEEM_EXPORT_COUNT: "Redemptions (uses of reward)",
            REWARD_REDEEM_EXPORT_NAMES: "Customers who redeemed (unique)",
            RECEIPT_REWARD_POINT: "Reward redemption rights",
            RECEIPT_REWARD_POINT_EXPORT_COL_NAME:
              "Reward (same segment as chart)",
            RECEIPT_REWARD_POINT_EXPORT_TOTAL_VALUE:
              "Total points (per segment)",
            RECEIPT_REWARD_POINT_EXPORT_NAMES:
              "Customers with rights to the same reward (unique)"
          },
          BTN_REVERT_APPROVE: "Revoke approval",
          CONFIRM_REVERT_APPROVE_TITLE: "Confirm revoking approval?",
          CONFIRM_REVERT_APPROVE:
            'The status will be reverted to "Waiting for approval" and the points the customer earned from this receipt will be deducted. Do you want to continue?',
          FIELDS: {
            ENABLE_VALUE_BASED_POINTS: "Award points by purchase value",
            VALUE_BASED_AMOUNT: "Purchase amount",
            VALUE_BASED_POINTS: "Points to award",
            ENABLE_REFERRAL: "Enable referral (Ref Code)",
            REFERRAL_HINT:
              "Each customer gets a referral code to share. When someone enters it at sign-up, both the inviter and the invitee earn the configured points.",
            REFERRAL_INVITER_POINT: "Inviter points",
            REFERRAL_INVITEE_POINT: "Invitee points",
            TERM_AND_CONDITION: "Terms and conditions",
            CUSTOMER: "Customer",
            RECEIPT_TYPE: "Receipt type",
            DESELECT_ALL_RECEIPT_TYPES: "Deselect all",
            REWARD: "Reward",
            IS_APPROVE: "Approval",
            REASON_NOT_APPROVE: "REASON NOT APPROVE",
            UNAPPROVED_REASON_REMARK: "REASON REMARK",
            POINT: "Point",
            VERIFY_CODE: "Verify code",
            REMARK: "Remark",
            RECEIPT_VERIFY_REGEX: "Receipt number pattern (regex)",
            RECEIPT_VERIFY_REGEX_PLACEHOLDER: "e.g. ^[A-Z0-9-]+$",
            RECEIPT_VERIFY_REGEX_HINT:
              "Optional. When set, receipt number text (e.g. after OCR) can be checked against this pattern."
          }
        }
      }
    }
  },
  RESPONSE_MESSAGE: {
    ERROR_OCCURRED: "System error occurred",
    USER_NOT_FOUND: "User not found",
    EMAIL_DUPLICATE: "This email has already been used.",
    CODE_EXPIRED: "Code expired",
    SAVE_DATA_SUCCESS: "Success to save data",
    SAVE_DATA_SUCCESS_LINE_TOKEN_AUTH_FAILE:
      "<p style='color:red;'>The work message will not be notified due to an invalid Line Message Token. Please check again.</p>",
    SAVE_DATA_FAILURE: "Failed to save data",
    DELETE_DATA_SUCCESS: "Success to delete data",
    DELETE_DATA_FAILURE: "Failed to delete data",
    DATA_INVALID: "Incorrect information",
    DATA_NOT_FOUND: "Data not found",
    DATA_DUPLICATE: "Data dupicate",
    COMPANY_NAME_DUPLICATE: "This company name has already been used.",
    VERIFY_CODE_DUPLICATE: "This verify code has already been used.",
    PLAN_REQUIRED_PRO: "This feature is available on the Pro plan only."
  },
  LOADING: "loading"
};
